import { useEffect } from "react";
import { Path } from "../configs/routes";
import { useStore } from "../store";
import { useEntity } from "./useEntity";

/**
 * Redirects to `fallbackPath` when Pix is disabled on the totem.
 *
 * `isPixFlow` must be false whenever the screen also serves non-Pix payment
 * methods, otherwise the card flow gets redirected away from its own screens.
 */
export const usePixEnabledGuard = (fallbackPath: Path, isPixFlow = true) => {
  const { navigation } = useStore();
  const { isPixEnabledOnTotem } = useEntity();

  useEffect(() => {
    if (isPixFlow && !isPixEnabledOnTotem) {
      navigation.navigateTo(fallbackPath);
    }
  }, [fallbackPath, isPixFlow, isPixEnabledOnTotem]);

  return isPixEnabledOnTotem;
};
